import { createProductConfig } from 'pricing-pages-lib/utils/productConfigUtils';
import { useCallback, useEffect } from 'react';
import { CORE_SEATS_ENTERPRISE, CORE_SEATS_PROFESSIONAL, CORE_SEATS_STARTER } from 'self-service-api/constants/ApiNames';
import { ENTERPRISE, PROFESSIONAL, STARTER } from 'self-service-api/constants/ProductLevels';
import { useAppSelector } from '../../reducers';
import { includedCoreSeatsQuantitySelector, productLevelForCoreSeatsSelector } from '../../selectors/ProductConfigsSelectors';
import { productsFromProductInventoryQuantitySelector } from '../../selectors/ProductInventorySelectors';
import { currentSkuIdForProductSelector } from '../../selectors/ProductsSelectors';
export const ApiNameByPaidProductLevel = {
  [STARTER]: CORE_SEATS_STARTER,
  [PROFESSIONAL]: CORE_SEATS_PROFESSIONAL,
  [ENTERPRISE]: CORE_SEATS_ENTERPRISE
};
export const useCoreSeats = ({
  productConfigurations,
  setProductConfigurations
}) => {
  const productLevelForCoreSeats = useAppSelector(state => productLevelForCoreSeatsSelector(state, {
    productConfigurations
  }));
  const includedCoreSeatsQuantity = useAppSelector(state => includedCoreSeatsQuantitySelector(state, {
    productConfigurations
  }));
  const apiNameForCoreSeats = ApiNameByPaidProductLevel[productLevelForCoreSeats];
  const skuIdCoreSeat = useAppSelector(state => currentSkuIdForProductSelector(state, {
    apiName: apiNameForCoreSeats
  }));
  const ownedCoreSeatsQuantity = useAppSelector(state => productsFromProductInventoryQuantitySelector(state, {
    skuId: skuIdCoreSeat
  }));
  const foundConfig = productConfigurations.find(({
    skuId
  }) => skuId === skuIdCoreSeat);
  const purchasableCoreSeatsQuantity = foundConfig ? foundConfig.quantity : 0;
  const setPurchasableCoreSeatsQuantity = useCallback(quantity => {
    setProductConfigurations(oldProductConfigurations => {
      const filteredConfigs = oldProductConfigurations.filter(({
        skuId
      }) => skuId !== skuIdCoreSeat);

      if (quantity > 0) {
        filteredConfigs.push(createProductConfig({
          skuId: skuIdCoreSeat,
          quantity
        }));
      }

      return filteredConfigs;
    });
  }, [skuIdCoreSeat, setProductConfigurations]);
  useEffect(() => {
    if (purchasableCoreSeatsQuantity < ownedCoreSeatsQuantity) {
      setPurchasableCoreSeatsQuantity(ownedCoreSeatsQuantity);
    }
  }, [purchasableCoreSeatsQuantity, ownedCoreSeatsQuantity, setPurchasableCoreSeatsQuantity]);
  return {
    productLevelForCoreSeats,
    includedCoreSeatsQuantity,
    ownedCoreSeatsQuantity,
    coreSeatsToPurchaseQuantity: purchasableCoreSeatsQuantity,
    setCoreSeatsToPurchaseQuantity: setPurchasableCoreSeatsQuantity
  };
};